import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ITagPostRequestModel, ITagType } from 'dist/lib-core-shared/lib/models/product/dto/tags/product-tags.model';
import { ProductTagsService } from 'lib-core-shared';

@Component({
  selector: 'app-create-product-tag',
  templateUrl: './create-product-tag.component.html',
  styleUrls: ['./create-product-tag.component.scss']
})
export class CreateProductTagComponent implements OnInit {
  public form: FormGroup;
  @Input() prefill!: string;
  @Output() closeModal = new EventEmitter<boolean>();
  @Output() saveCloseModal = new EventEmitter<any>();
  isBusy: boolean = false;
  fb: any;
  @Input() tagTypes!: ITagType[];
  
  constructor(private productTagsService: ProductTagsService) {
    this.form = new FormGroup({
      tagType: new FormControl(null, [Validators.required]),
      tagTitleEn: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      tagTitleUs: new FormControl(null, [Validators.maxLength(255)]),
      tagTitleFr: new FormControl(null, [Validators.maxLength(255)]),
      tagTitleNl: new FormControl(null, [Validators.maxLength(255)]),
      tagTitleDe: new FormControl(null, [Validators.maxLength(255)])
    })
  }

  ngOnInit(): void {
    if (this.prefill) {
      this.form.controls.tagTitleEn.setValue(this.prefill);
    }
  }

  close() {
    this.closeModal.emit(true);
  }

  save() {    
    if (this.form.valid) {
      delete this.fb;
      this.isBusy = true;

      let dto: ITagPostRequestModel = {
        tagTypeCode: this.form.value.tagType.code,
        tags: this.dtoMapper(this.form.value)
      }

      if (dto.tagTypeCode && dto.tags && dto.tags.length) {
        this.productTagsService.createTag(dto).subscribe((res: any) => {
          if (res) {
            this.isBusy = false;
            this.saveCloseModal.emit({mode: 'create', response: res})
          }
        }, error => {
          if (error) {
            this.isBusy = false;
        
            if (error.status !== 404) {
              this.fb = {
                text: error.error,
                error: error
              };
                  
              setTimeout(() => {
                let errorCard = document.getElementsByTagName('lib-error');
                errorCard[0].scrollIntoView({block: "end", inline: "center", behavior: "smooth"});
              }, 0)
            }
          }
        });
      }
    }
  }

  dtoMapper(formValues: any) {
    let arr = [];

    if (formValues && formValues.tagTitleEn) {
      arr.push({languageCode: "EN", title: formValues.tagTitleEn});

      if (formValues.tagTitleUs) {
        arr.push({languageCode: "US", title: formValues.tagTitleUs});
      }
  
      if (formValues.tagTitleFr) {
        arr.push({languageCode: "FR", title: formValues.tagTitleFr});
      }
  
      if (formValues.tagTitleNl) {
        arr.push({languageCode: "NL", title: formValues.tagTitleNl});
      }
  
      if (formValues.tagTitleDe) {
        arr.push({languageCode: "DE", title: formValues.tagTitleDe});
      }
    }

    return arr;
  }

  public getErrorMsgText():string {
    return this.fb?.text ? this.fb.text : '';
  }
}
